module.exports = __webpack_public_path__ + "img/stage.a18a0ff0.png";